import { useState } from "react";

const categories = [
  { id: "all", label: "הכל", icon: "ri-apps-line", color: "#A78BFA" },

  { id: "workshops", label: "סדנאות", icon: "ri-tools-line", color: "#FCA5A5" },

  { id: "jobs", label: "משרות", icon: "ri-briefcase-line", color: "#6EE7B7" },
  { id: "webinars", label: "וובינרים", icon: "ri-live-line", color: "#A78BFA" },
  {
    id: "employment",
    label: "ליווי תעסוקתי",
    icon: "ri-user-heart-line",
    color: "#93C5FD",
  },
  {
    id: "business",
    label: "ליווי עסקי",
    icon: "ri-bar-chart-line",
    color: "#F9A8D4",
  },
];

export default function CategoryPills() {
  const [active, setActive] = useState("all");

  const handleClick = (id: string) => {
    if (id === "employment") {
      document
        .getElementById("main-cards")
        ?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    if (id === "business") {
      document
        .getElementById("main-cards")
        ?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="py-3" dir="rtl">
      <div className="overflow-x-auto scrollbar-hide">
        <div className="flex gap-3 px-4 pb-1" style={{ width: "max-content" }}>
          {categories.map((cat) => {
            const isActive = active === cat.id;
            return (
              <button
                key={cat.id}
                onClick={() => {
                  setActive(cat.id);
                  handleClick(cat.id);
                }}
                className="flex items-center gap-2 rounded-full px-4 py-2.5 border-2 border-gray-900 transition-all whitespace-nowrap cursor-pointer"
                style={{
                  background: isActive ? cat.color : "#fff",
                  transform: isActive ? "scale(1.05)" : "scale(1)",
                }}
              >
                <i
                  className={`${cat.icon} text-base`}
                  style={{ color: isActive ? "#1F2937" : cat.color }}
                ></i>
                <span
                  className="text-sm font-bold"
                  style={{ color: isActive ? "#1F2937" : "#374151" }}
                >
                  {cat.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
